/**
 * Wait until ref is loaded
 *
 * Usage:
 * await getRef.call(this, 'YOUR-REF-HERE')
 */
export async function getRef(name) {
  let ref;

  while (!ref) {
    ref = this.$refs[name];

    await new Promise((resolve) => requestAnimationFrame(resolve));
  }

  return ref;
}

export function clickElementById(id) {
  const el = document.getElementById(id);
  el.click();
}
